import React, { Component } from 'react';
import { connect } from 'react-redux';

class Perfil extends Component {
  render () {
    const { fetching, user: {displayName, email} } = this.props.value;

    return (2 === fetching?<div>Você está logado como <strong>{displayName} ({email})</strong>.</div>:null);
  }
}

let mapStateToProps = ({ auth }) => ({
  value: auth
});

export default connect(mapStateToProps, null)(Perfil)


// WEBPACK FOOTER //
// ./src/Perfil.js